import { USER_PROFILE } from "./constants/actionTypes";

const initialState = {
  fetching: false,
  fetched: false,
  onError: false,
  error: {},
  resp: {}
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_PROFILE.pending: {
      return {
        ...state,
        fetching: true,
        fetched: false,
        onError: false,
        error: {}
      };
    }
    case USER_PROFILE.fulfilled: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: {},
        resp: action.payload.data
      };
    }
    case USER_PROFILE.rejected: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        onError: true,
        error: action.payload
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
};

export default reducer;
